<div class="page">

  <div class="page-header">
    <div class="header-left">
      <button class="btn-back" (click)="goBack()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
        Back
      </button>
      <div>
        <h1>New Compound</h1>
        <p>Create a new real-estate compound</p>
      </div>
    </div>
  </div>

  <div class="error-msg" *ngIf="errorMessage">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/>
      <line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
    {{ errorMessage }}
  </div>

  <form class="form-card" (ngSubmit)="onSubmit()">

    <!-- ── Basic Info ── -->
    <div class="form-section">
      <h2 class="section-title">Compound Info</h2>

      <div class="form-row">
        <div class="form-group">
          <label>Developer <span class="required">*</span></label>
          <select [(ngModel)]="form.developer_id" name="developer_id">
            <option [ngValue]="0" disabled>Select a developer</option>
            <option *ngFor="let d of developers" [ngValue]="d.id">{{ d.name_en || d.name_ar }}</option>
          </select>
        </div>
      </div>

      <!-- Name bilingual card -->
      <div class="bilingual-block">
        <div class="bilingual-inputs">
          <div class="form-group">
            <label>Arabic Name <span class="required">*</span></label>
            <input type="text" [(ngModel)]="form.name_ar" name="name_ar"
              placeholder="مشروع سيليا" dir="rtl" />
          </div>
          <div class="form-group">
            <label>English Name</label>
            <input type="text" [(ngModel)]="form.name_en" name="name_en"
              placeholder="Selia Compound" />
          </div>
        </div>
        <div class="translate-strip">
          <button type="button" class="btn-translate"
            (click)="translateNameToAr()"
            [disabled]="translating.nameToAr || !form.name_en?.trim()">
            <span *ngIf="!translating.nameToAr">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="15 18 9 12 15 6"/>
              </svg>
              Translate EN → AR
            </span>
            <span *ngIf="translating.nameToAr" class="spinner-xs"></span>
          </button>
          <span class="translate-divider">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 8l4-4 4 4M9 4v16M19 8l-4 4 4 4M15 4v16" />
            </svg>
            Name Auto-translate
          </span>
          <button type="button" class="btn-translate"
            (click)="translateNameToEn()"
            [disabled]="translating.nameToEn || !form.name_ar?.trim()">
            <span *ngIf="!translating.nameToEn">
              Translate AR → EN
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"/>
              </svg>
            </span>
            <span *ngIf="translating.nameToEn" class="spinner-xs"></span>
          </button>
        </div>
        <div class="translate-error" *ngIf="translateErrors.nameToEn || translateErrors.nameToAr">
          Translation failed — please try again.
        </div>
      </div>

      <!-- Description bilingual card -->
      <div class="bilingual-block">
        <div class="bilingual-inputs">
          <div class="form-group">
            <label>Description (Arabic)</label>
            <textarea [(ngModel)]="form.desc_ar" name="desc_ar"
              rows="3" placeholder="وصف المشروع بالعربية" dir="rtl"></textarea>
          </div>
          <div class="form-group">
            <label>Description (English)</label>
            <textarea [(ngModel)]="form.desc_en" name="desc_en"
              rows="3" placeholder="Compound description in English"></textarea>
          </div>
        </div>
        <div class="translate-strip">
          <button type="button" class="btn-translate"
            (click)="translateDescToAr()"
            [disabled]="translating.descToAr || !form.desc_en?.trim()">
            <span *ngIf="!translating.descToAr">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="15 18 9 12 15 6"/>
              </svg>
              Translate EN → AR
            </span>
            <span *ngIf="translating.descToAr" class="spinner-xs"></span>
          </button>
          <span class="translate-divider">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 8l4-4 4 4M9 4v16M19 8l-4 4 4 4M15 4v16" />
            </svg>
            Description Auto-translate
          </span>
          <button type="button" class="btn-translate"
            (click)="translateDescToEn()"
            [disabled]="translating.descToEn || !form.desc_ar?.trim()">
            <span *ngIf="!translating.descToEn">
              Translate AR → EN
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"/>
              </svg>
            </span>
            <span *ngIf="translating.descToEn" class="spinner-xs"></span>
          </button>
        </div>
        <div class="translate-error" *ngIf="translateErrors.descToEn || translateErrors.descToAr">
          Translation failed — please try again.
        </div>
      </div>

      <!-- Active toggle -->
      <div class="form-group check-group">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="form.is_active" name="is_active" />
          <span>Active</span>
        </label>
      </div>
    </div>

    <div class="form-divider"></div>

    <!-- ── Location & defaults for every unit ── -->
    <div class="form-section">
      <h2 class="section-title">Location &amp; unit defaults</h2>
      <p class="section-desc">
        Area, delivery, finishing and payment are set once here and apply to every unit in this compound.
        A single unit can override them. Launches and offers are added from the compound’s page after saving.
      </p>
      <div class="form-group">
        <label>Area</label>
        <select [(ngModel)]="form.area_id" name="area_id">
          <option [ngValue]="null">— not set —</option>
          <option *ngFor="let a of areas" [ngValue]="a.id">{{ a.name_en || a.name_ar }}</option>
        </select>
      </div>
      <app-listing-attributes-fields [form]="$any(form)" tagsKey="amenities"></app-listing-attributes-fields>
    </div>

    <div class="form-divider"></div>

    <div class="form-section">
      <app-compound-profile-fields [form]="form"></app-compound-profile-fields>
    </div>

    <div class="form-divider"></div>

    <div class="form-section">
      <app-compound-reference-fields [form]="form"></app-compound-reference-fields>
    </div>

    <div class="form-divider"></div>

    <!-- ── Main Image ── -->
    <div class="form-section">
      <h2 class="section-title">Main Image</h2>
      <p class="section-desc">Cover image shown on the compound card.</p>

      <app-media-uploader
        folder="compounds"
        [multiple]="false"
        (uploaded)="onMainImageUploaded($event)">
      </app-media-uploader>

      <div class="url-fallback">
        <span class="or-label">or paste URL</span>
        <input type="text" [(ngModel)]="form.main_image" name="main_image"
          placeholder="https://example.com/compound-cover.jpg" class="url-input" />
      </div>

      <div class="main-image-preview" *ngIf="form.main_image">
        <img [src]="form.main_image" alt="main image preview" />
      </div>
    </div>

    <div class="form-divider"></div>

    <!-- ── Gallery ── -->
    <div class="form-section">
      <h2 class="section-title">Gallery</h2>

      <app-media-uploader
        folder="compounds"
        [multiple]="true"
        (uploaded)="onGalleryUploaded($event)">
      </app-media-uploader>

      <div class="url-fallback">
        <span class="or-label">or paste URL</span>
        <div class="url-input-row">
          <input type="text" [(ngModel)]="galleryInput" name="galleryInput"
            placeholder="https://example.com/photo.jpg"
            (keydown)="onGalleryKeydown($event)" class="url-input" />
          <button type="button" class="btn-add" (click)="addGalleryImage()">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
            Add
          </button>
        </div>
      </div>

      <div class="thumb-grid" *ngIf="form.gallery.length > 0">
        <div class="thumb-item" *ngFor="let url of form.gallery; let i = index">
          <img [src]="url" [alt]="'gallery-' + i" class="thumb-img" />
          <button type="button" class="btn-remove-thumb" (click)="removeGalleryImage(i)">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
      </div>
      <p class="empty-hint" *ngIf="form.gallery.length === 0">No images added yet.</p>
    </div>

    <div class="form-divider"></div>

    <!-- ── Features ── -->
    <div class="form-section">
      <div class="section-header">
        <div>
          <h2 class="section-title">Features</h2>
          <p class="section-desc">Add sections describing the compound's amenities and services.</p>
        </div>
        <button type="button" class="btn-add-feature" (click)="openFeatureForm()" *ngIf="!showFeatureForm">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
          Add Feature
        </button>
      </div>

      <!-- Added features list -->
      <div class="features-list" *ngIf="form.features.length > 0">
        <div class="feature-card" *ngFor="let f of form.features; let i = index">
          <div class="feature-card-header">
            <div>
              <span class="feature-title-en">{{ f.title_en || '—' }}</span>
              <span class="feature-title-ar" dir="rtl">{{ f.title_ar || '—' }}</span>
            </div>
            <div class="feature-card-meta">
              <span class="feature-img-count" *ngIf="f.images.length > 0">{{ f.images.length }} img</span>
              <button type="button" class="btn-remove-feature" (click)="removeFeature(i)">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
            </div>
          </div>
          <p class="feature-subtitle">{{ f.subtitle_en }}</p>
        </div>
      </div>
      <p class="empty-hint" *ngIf="form.features.length === 0 && !showFeatureForm">No features added yet.</p>

      <!-- New feature builder -->
      <div class="feature-builder" *ngIf="showFeatureForm">
        <h3 class="builder-title">New Feature</h3>

        <!-- Title bilingual card -->
        <div class="bilingual-block">
          <div class="bilingual-inputs">
            <div class="form-group">
              <label>Title (Arabic) <span class="required">*</span></label>
              <input type="text" [(ngModel)]="newFeature.title_ar" name="feat_title_ar"
                placeholder="المرافق و الخدمات" dir="rtl" />
            </div>
            <div class="form-group">
              <label>Title (English)</label>
              <input type="text" [(ngModel)]="newFeature.title_en" name="feat_title_en"
                placeholder="Facilities & Services" />
            </div>
          </div>
          <div class="translate-strip">
            <button type="button" class="btn-translate"
              (click)="translateFeatTitleToAr()"
              [disabled]="translating.featTitleToAr || !newFeature.title_en?.trim()">
              <span *ngIf="!translating.featTitleToAr">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="15 18 9 12 15 6"/>
                </svg>
                Translate EN → AR
              </span>
              <span *ngIf="translating.featTitleToAr" class="spinner-xs"></span>
            </button>
            <span class="translate-divider">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 8l4-4 4 4M9 4v16M19 8l-4 4 4 4M15 4v16" />
              </svg>
              Title Auto-translate
            </span>
            <button type="button" class="btn-translate"
              (click)="translateFeatTitleToEn()"
              [disabled]="translating.featTitleToEn || !newFeature.title_ar?.trim()">
              <span *ngIf="!translating.featTitleToEn">
                Translate AR → EN
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="9 18 15 12 9 6"/>
                </svg>
              </span>
              <span *ngIf="translating.featTitleToEn" class="spinner-xs"></span>
            </button>
          </div>
          <div class="translate-error" *ngIf="translateErrors.featTitleToEn || translateErrors.featTitleToAr">
            Translation failed — please try again.
          </div>
        </div>

        <!-- Subtitle bilingual card -->
        <div class="bilingual-block">
          <div class="bilingual-inputs">
            <div class="form-group">
              <label>Subtitle (Arabic)</label>
              <input type="text" [(ngModel)]="newFeature.subtitle_ar" name="feat_subtitle_ar"
                placeholder="وصف مختصر بالعربية" dir="rtl" />
            </div>
            <div class="form-group">
              <label>Subtitle (English)</label>
              <input type="text" [(ngModel)]="newFeature.subtitle_en" name="feat_subtitle_en"
                placeholder="Short subtitle in English" />
            </div>
          </div>
          <div class="translate-strip">
            <button type="button" class="btn-translate"
              (click)="translateFeatSubtitleToAr()"
              [disabled]="translating.featSubtitleToAr || !newFeature.subtitle_en?.trim()">
              <span *ngIf="!translating.featSubtitleToAr">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="15 18 9 12 15 6"/>
                </svg>
                Translate EN → AR
              </span>
              <span *ngIf="translating.featSubtitleToAr" class="spinner-xs"></span>
            </button>
            <span class="translate-divider">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 8l4-4 4 4M9 4v16M19 8l-4 4 4 4M15 4v16" />
              </svg>
              Subtitle Auto-translate
            </span>
            <button type="button" class="btn-translate"
              (click)="translateFeatSubtitleToEn()"
              [disabled]="translating.featSubtitleToEn || !newFeature.subtitle_ar?.trim()">
              <span *ngIf="!translating.featSubtitleToEn">
                Translate AR → EN
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="9 18 15 12 9 6"/>
                </svg>
              </span>
              <span *ngIf="translating.featSubtitleToEn" class="spinner-xs"></span>
            </button>
          </div>
          <div class="translate-error" *ngIf="translateErrors.featSubtitleToEn || translateErrors.featSubtitleToAr">
            Translation failed — please try again.
          </div>
        </div>

        <!-- Feature images -->
        <div class="form-group">
          <label>Feature Images</label>
          <app-media-uploader
            folder="compounds"
            [multiple]="true"
            (uploaded)="onFeatureImagesUploaded($event)">
          </app-media-uploader>
          <div class="url-fallback">
            <span class="or-label">or paste URL</span>
            <div class="url-input-row">
              <input type="text" [(ngModel)]="featureImageInput" name="featureImageInput"
                placeholder="https://example.com/feature.jpg"
                (keydown)="onFeatureImageKeydown($event)" class="url-input" />
              <button type="button" class="btn-add" (click)="addFeatureImage()">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
                </svg>
                Add
              </button>
            </div>
          </div>
          <div class="thumb-grid" *ngIf="newFeature.images.length > 0">
            <div class="thumb-item" *ngFor="let url of newFeature.images; let i = index">
              <img [src]="url" [alt]="'feat-img-' + i" class="thumb-img" />
              <button type="button" class="btn-remove-thumb" (click)="removeFeatureImage(i)">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div class="builder-actions">
          <button type="button" class="btn-secondary" (click)="cancelFeature()">Cancel</button>
          <button type="button" class="btn-primary" (click)="addFeature()">Add Feature</button>
        </div>
      </div>
    </div>

    <div class="form-divider"></div>

    <div class="form-actions">
      <button type="button" class="btn-secondary" (click)="goBack()">Cancel</button>
      <button type="submit" class="btn-primary" [disabled]="isSubmitting">
        <span *ngIf="!isSubmitting">Create Compound</span>
        <span *ngIf="isSubmitting" class="spinner-sm"></span>
      </button>
    </div>

  </form>
</div>
